import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InvoiceGridLoading from './invoice-grid-loading';
import baseColumns from './invoice-grid-columns';
import style from '../style.module.less';
import InvoicesGridPlaceholder from './invoices-placeholder';
import InvoicesGridErrorPlaceholder from './invoices-error-placeholder';
import { InvoicesContext } from '../invoices-context';

const InvoiceDetail = ({ invoiceId }) => baseColumns.map((column) => <div key={column.id}>{column.render({ invoiceId })}</div>);

InvoiceDetail.propTypes = {
  invoiceId: PropTypes.string.isRequired,
};

const InvoicesGrid = ({ shouldShowLeftNavWhenLoading = false }) => {
  const { invoiceIds, isLoading, hasError } = useContext(InvoicesContext);
  const isEmptyGrid = !isLoading && !invoiceIds.length;

  return (
    <>
      {isEmptyGrid && !hasError && <InvoicesGridPlaceholder />}
      {hasError && <InvoicesGridErrorPlaceholder />}
      <div className={classnames(style['grid-container'], style['invoices-grid-container'])}>
        {isLoading ? (
          <InvoiceGridLoading shouldShowLeftNavWhenLoading={shouldShowLeftNavWhenLoading} />
        ) : (
          invoiceIds.map((invoiceId, index) => <InvoiceDetail key={index} invoiceId={invoiceId} />)
        )}
      </div>
    </>
  );
};

InvoicesGrid.propTypes = {
  shouldShowLeftNavWhenLoading: PropTypes.bool,
};

export default InvoicesGrid;
